// extracted by mini-css-extract-plugin
export default {"edit":"EditBalance_edit__3ft-6","input":"EditBalance_input__AKOBU","desc":"EditBalance_desc__3tG+a","action":"EditBalance_action__9oRM2"};